import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useEffect, useState } from 'react';
import { Translate, translate, ValidatedField, ValidatedForm } from 'react-jhipster';
import { Link, RouteComponentProps } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';

import { useAppDispatch, useAppSelector } from 'app/config/store';
import { createEntity, getEntity, reset, updateEntity } from './sensor-hardware.reducer';

export const SensorHardwareUpdate = (props: RouteComponentProps<{ id: string }>) => {
  const dispatch = useAppDispatch();

  const [isNew] = useState(!props.match.params || !props.match.params.id);

  const sensorHardwareEntity = useAppSelector(state => state.sensorHardware.entity);
  const loading = useAppSelector(state => state.sensorHardware.loading);
  const updating = useAppSelector(state => state.sensorHardware.updating);
  const updateSuccess = useAppSelector(state => state.sensorHardware.updateSuccess);

  const handleClose = () => {
    props.history.push('/sensor-hardware' + props.location.search);
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(props.match.params.id));
    }
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    const entity = {
      ...sensorHardwareEntity,
      ...values,
      equation: values.equation.replaceAll(',', '.')
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {}
      : {
          ...sensorHardwareEntity,
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2 id="fleetSenseApp.sensorHardware.home.createOrEditLabel" data-cy="SensorHardwareCreateUpdateHeading">
            <Translate contentKey="fleetSenseApp.sensorHardware.home.createOrEditLabel">Create or edit a SensorHardware</Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField
                  name="id"
                  required
                  readOnly
                  id="sensor-hardware-id"
                  label={translate('global.field.id')}
                  validate={{ required: true }}
                  className="d-none"
                />
              ) : null}
              {/* <ValidatedField
                label={translate('fleetSenseApp.sensorHardware.manufacturer')}
                id="sensor-hardware-manufacturer"
                name="manufacturer"
                data-cy="manufacturer"
                type="text"
              />
              <ValidatedField
                label={translate('fleetSenseApp.sensorHardware.model')}
                id="sensor-hardware-model"
                name="model"
                data-cy="model"
                type="text"
              /> */}
              <ValidatedField
                label={translate('fleetSenseApp.sensorHardware.description')}
                id="sensor-hardware-description"
                name="description"
                data-cy="description"
                type="text"
              />
              <ValidatedField
                label={translate('fleetSenseApp.sensorHardware.equation')}
                id="sensor-hardware-equation"
                name="equation"
                data-cy="equation"
                type="text"
              />
              <Button tag={Link} id="cancel-save" data-cy="entityCreateCancelButton" to="/sensor-hardware" replace color="info">
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button color="primary" id="save-entity" data-cy="entityCreateSaveButton" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default SensorHardwareUpdate;
